export default "__VITE_ASSET__B9yNQn$C__"